import { render, staticRenderFns } from "./PromotionSales.vue?vue&type=template&id=0a9bf75a"
import script from "./PromotionSales.vue?vue&type=script&lang=js"
export * from "./PromotionSales.vue?vue&type=script&lang=js"
import style0 from "./PromotionSales.vue?vue&type=style&index=0&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports